import { IpadsModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<IpadsModel>('/ipad/ipads');
export default api;
